// const TEST_DATA = [ { 'oc': true, 'oc_adp1': false, 'oc_adp2': false, 'ic1': false, 'ic1_adp1': false, 'ic1_adp2': false, 'ic2': false, 'ic2_adp1': false, 'ic2_adp2': false, 'ic3': false, 'ic3_adp1': false, 'ic3_adp2': false, 'ic4': false, 'ic4_adp1': false, 'ic4_adp2': false, 'rc': true }, { 'oc': true, 'oc_adp1': true, 'oc_adp2': false, 'ic1': true, 'ic1_adp1': true, 'ic1_adp2': false, 'ic2': true, 'ic2_adp1': false, 'ic2_adp2': false, 'ic3': true, 'ic3_adp1': true, 'ic3_adp2': true, 'ic4': false, 'ic4_adp1': false, 'ic4_adp2': false, 'rc': false }, { 'oc': true, 'oc_adp1': false, 'oc_adp2': false, 'ic1': false, 'ic1_adp1': false, 'ic1_adp2': false, 'ic2': false, 'ic2_adp1': false, 'ic2_adp2': false, 'ic3': false, 'ic3_adp1': false, 'ic3_adp2': false, 'ic4': false, 'ic4_adp1': false, 'ic4_adp2': false, 'rc': true }, { 'oc': false, 'oc_adp1': false, 'oc_adp2': false, 'ic1': false, 'ic1_adp1': false, 'ic1_adp2': false, 'ic2': false, 'ic2_adp1': false, 'ic2_adp2': false, 'ic3': false, 'ic3_adp1': false, 'ic3_adp2': false, 'ic4': false, 'ic4_adp1': false, 'ic4_adp2': false, 'rc': false }, { 'oc': false, 'oc_adp1': false, 'oc_adp2': false, 'ic1': false, 'ic1_adp1': false, 'ic1_adp2': false, 'ic2': false, 'ic2_adp1': false, 'ic2_adp2': false, 'ic3': false, 'ic3_adp1': false, 'ic3_adp2': false, 'ic4': false, 'ic4_adp1': false, 'ic4_adp2': false, 'rc': false }, { 'oc': false, 'oc_adp1': false, 'oc_adp2': false, 'ic1': false, 'ic1_adp1': false, 'ic1_adp2': false, 'ic2': false, 'ic2_adp1': false, 'ic2_adp2': false, 'ic3': false, 'ic3_adp1': false, 'ic3_adp2': false, 'ic4': false, 'ic4_adp1': false, 'ic4_adp2': false, 'rc': false }, { 'oc': false, 'oc_adp1': false, 'oc_adp2': false, 'ic1': false, 'ic1_adp1': false, 'ic1_adp2': false, 'ic2': false, 'ic2_adp1': false, 'ic2_adp2': false, 'ic3': false, 'ic3_adp1': false, 'ic3_adp2': false, 'ic4': false, 'ic4_adp1': false, 'ic4_adp2': false, 'rc': false }, { 'oc': false, 'oc_adp1': false, 'oc_adp2': false, 'ic1': false, 'ic1_adp1': false, 'ic1_adp2': false, 'ic2': false, 'ic2_adp1': false, 'ic2_adp2': false, 'ic3': false, 'ic3_adp1': false, 'ic3_adp2': false, 'ic4': false, 'ic4_adp1': false, 'ic4_adp2': false, 'rc': false }, { 'oc': false, 'oc_adp1': false, 'oc_adp2': false, 'ic1': false, 'ic1_adp1': false, 'ic1_adp2': false, 'ic2': false, 'ic2_adp1': false, 'ic2_adp2': false, 'ic3': false, 'ic3_adp1': false, 'ic3_adp2': false, 'ic4': false, 'ic4_adp1': false, 'ic4_adp2': false, 'rc': false }, { 'oc': false, 'oc_adp1': false, 'oc_adp2': false, 'ic1': false, 'ic1_adp1': false, 'ic1_adp2': false, 'ic2': false, 'ic2_adp1': false, 'ic2_adp2': false, 'ic3': false, 'ic3_adp1': false, 'ic3_adp2': false, 'ic4': false, 'ic4_adp1': false, 'ic4_adp2': false, 'rc': false }, { 'oc': false, 'oc_adp1': false, 'oc_adp2': false, 'ic1': false, 'ic1_adp1': false, 'ic1_adp2': false, 'ic2': false, 'ic2_adp1': false, 'ic2_adp2': false, 'ic3': false, 'ic3_adp1': false, 'ic3_adp2': false, 'ic4': false, 'ic4_adp1': false, 'ic4_adp2': false, 'rc': false }, { 'oc': false, 'oc_adp1': false, 'oc_adp2': false, 'ic1': false, 'ic1_adp1': false, 'ic1_adp2': false, 'ic2': false, 'ic2_adp1': false, 'ic2_adp2': false, 'ic3': false, 'ic3_adp1': false, 'ic3_adp2': false, 'ic4': false, 'ic4_adp1': false, 'ic4_adp2': false, 'rc': false }, { 'oc': false, 'oc_adp1': false, 'oc_adp2': false, 'ic1': false, 'ic1_adp1': false, 'ic1_adp2': false, 'ic2': false, 'ic2_adp1': false, 'ic2_adp2': false, 'ic3': false, 'ic3_adp1': false, 'ic3_adp2': false, 'ic4': false, 'ic4_adp1': false, 'ic4_adp2': false, 'rc': false }, { 'oc': false, 'oc_adp1': false, 'oc_adp2': false, 'ic1': false, 'ic1_adp1': false, 'ic1_adp2': false, 'ic2': false, 'ic2_adp1': false, 'ic2_adp2': false, 'ic3': false, 'ic3_adp1': false, 'ic3_adp2': false, 'ic4': false, 'ic4_adp1': false, 'ic4_adp2': false, 'rc': false }, { 'oc': false, 'oc_adp1': false, 'oc_adp2': false, 'ic1': false, 'ic1_adp1': false, 'ic1_adp2': false, 'ic2': false, 'ic2_adp1': false, 'ic2_adp2': false, 'ic3': false, 'ic3_adp1': false, 'ic3_adp2': false, 'ic4': false, 'ic4_adp1': false, 'ic4_adp2': false, 'rc': false }, { 'oc': false, 'oc_adp1': false, 'oc_adp2': false, 'ic1': false, 'ic1_adp1': false, 'ic1_adp2': false, 'ic2': false, 'ic2_adp1': false, 'ic2_adp2': false, 'ic3': false, 'ic3_adp1': false, 'ic3_adp2': false, 'ic4': false, 'ic4_adp1': false, 'ic4_adp2': false, 'rc': false } ]

const EACH_ROW = {
  system_config_no: '',
  type: '',
  address: '',
  OC: '',
  OC_ADP: '',
  IC: '',
  IC_ADP: '',
  RC: ''
}

function convertTableData (systemConfigData, systemConfigNo) {
  const tempResult = systemConfigData.map((eachAd, index) => {
    const isEmpty = Object.values(eachAd).every(elm => {
      return !elm
    })
    if (!isEmpty) {
      const eachAddress = eachAddressConvert(eachAd, systemConfigNo, index)
      return eachAddress
    }
  })
  const result = tempResult.filter(elm => {
    return elm !== undefined
  })
  const mergeResult = result.reduce((acc, cur) => {
    return acc.concat(cur)
  }, [])

  return mergeResult
}

function eachAddressConvert (eachData, systemConfigNo, addressNo) {
  const eachAddress = []
  for (let i = 0; i < 9; i++) {
    eachAddress.push(JSON.parse(JSON.stringify(EACH_ROW)))
  }
  // ===== oc =====
  if (eachData.oc) {
    eachAddress[0].OC = 'OC'
  }
  if (eachData.oc_adp1) {
    eachAddress[0].OC_ADP = 'ADP1'
  }
  if (eachData.oc_adp2) {
    eachAddress[1].OC = 'OC'
    eachAddress[1].OC_ADP = 'ADP2'
  }
  // ===== ic1 =====
  if (eachData.ic1) {
    eachAddress[0].IC = 'IC1'
  }
  if (eachData.ic1_adp1) {
    eachAddress[0].IC_ADP = 'ADP1'
  }
  if (eachData.ic1_adp2) {
    eachAddress[1].IC = 'IC1'
    eachAddress[1].IC_ADP = 'ADP2'
  }
  // ===== ic2 =====
  if (eachData.ic2) {
    eachAddress[2].IC = 'IC2'
  }
  if (eachData.ic2_adp1) {
    eachAddress[2].IC_ADP = 'ADP1'
  }
  if (eachData.ic2_adp2) {
    eachAddress[3].IC = 'IC2'
    eachAddress[3].IC_ADP = 'ADP2'
  }
  // ===== ic3 =====
  if (eachData.ic3) {
    eachAddress[4].IC = 'IC3'
  }
  if (eachData.ic3_adp1) {
    eachAddress[4].IC_ADP = 'ADP1'
  }
  if (eachData.ic3_adp2) {
    eachAddress[5].IC = 'IC3'
    eachAddress[5].IC_ADP = 'ADP2'
  }
  // ===== ic4 =====
  if (eachData.ic4) {
    eachAddress[6].IC = 'IC4'
  }
  if (eachData.ic4_adp1) {
    eachAddress[6].IC_ADP = 'ADP1'
  }
  if (eachData.ic4_adp2) {
    eachAddress[7].IC = 'IC4'
    eachAddress[7].IC_ADP = 'ADP2'
  }
  // ===== rc =====
  if (eachData.rc) {
    eachAddress[8].RC = 'RC'
    eachAddress[8].type = 'コントローラー'
  }
  eachAddress.forEach((elm, index) => {
    if (
      elm.OC !== '' ||
      elm.OC_ADP !== '' ||
      elm.IC !== '' ||
      elm.IC_ADP !== '' ||
      elm.RC !== ''
    ) {
      elm.system_config_no = systemConfigNo
      if (elm.type === '') {
        elm.type = '冷媒'
      }
      elm.address = addressNo
    }
  })
  const tempTableItems = JSON.parse(JSON.stringify(eachAddress))
  const tableItems = tempTableItems.filter(row => {
    return row.system_config_no !== ''
  })
  return tableItems
}
module.exports = convertTableData
